module.exports = __webpack_public_path__ + "static/media/boneshards.7097feea.webp";